'use client';

import { c as _c } from "react/compiler-runtime";
import { ReactNode, useEffect } from 'react';
import { CmsPageTakeover } from '@spa/top-level-components/cms-page/CmsComponentPage';
import { ImageAiMarkerComponent } from '@spa/components/image-ai-marker/image-ai-marker.component';
import ImageComponent from '@spa/components/image-component/image.component';
import TakeoverTopBannerComponent from './takeover-top-banner.component';
import classNames from 'clsx';
import styles from './takeover-frame.component.module.scss';
const digitalSourceTypeAttr = (enabled: boolean): Record<string, string> => enabled ? {
  'data-digital-source-type': 'compositeWithTrainedAlgorithmicMedia'
} : {};
export interface Props {
  readonly takeover: CmsPageTakeover | null;
  readonly onDismiss?: () => void;
}
function TakeoverFrameComponent(t0) {
  const $ = _c(6);
  const {
    takeover,
    onDismiss
  } = t0;
  let t1;
  let t2;
  if ($[0] !== takeover) {
    t1 = () => {
      if (takeover !== null) {
        document.body.classList.add("has-takeover");
      } else {
        document.body.classList.remove("has-takeover");
      }
      return _temp;
    };
    t2 = [takeover];
    $[0] = takeover;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== onDismiss || $[4] !== takeover) {
    t3 = takeover !== null && <div className={styles.frame} data-testid="takeover-frame"><div className={classNames(styles.frame__rail, styles["frame__rail--left"])} data-testid="takeover-left-rail"><ImageComponent src={takeover.leftBanner.imgSrc} alt="" width={takeover.leftBanner.width} height={takeover.leftBanner.height} mimeType={takeover.leftBanner.mimeType} className={styles["frame__rail-image"]} sizes="50vw" {...digitalSourceTypeAttr(takeover.leftBanner.aiLabel?.enabled === true)} />{takeover.leftBanner.aiLabel && <ImageAiMarkerComponent show={takeover.leftBanner.aiLabel.enabled} position={takeover.leftBanner.aiLabel.position} style={takeover.leftBanner.aiLabel.style} alt="" />}</div><div className={styles["frame__center-column"]} data-testid="takeover-center-column"><TakeoverTopBannerComponent takeover={takeover} onDismiss={onDismiss} /></div><div className={classNames(styles.frame__rail, styles["frame__rail--right"])} data-testid="takeover-right-rail"><ImageComponent src={takeover.rightBanner.imgSrc} alt="" width={takeover.rightBanner.width} height={takeover.rightBanner.height} mimeType={takeover.rightBanner.mimeType} className={styles["frame__rail-image"]} sizes="50vw" {...digitalSourceTypeAttr(takeover.rightBanner.aiLabel?.enabled === true)} />{takeover.rightBanner.aiLabel && <ImageAiMarkerComponent show={takeover.rightBanner.aiLabel.enabled} position={takeover.rightBanner.aiLabel.position} style={takeover.rightBanner.aiLabel.style} alt="" />}</div></div>;
    $[3] = onDismiss;
    $[4] = takeover;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function _temp() {
  document.body.classList.remove("has-takeover");
}
export default TakeoverFrameComponent;